import { Avatar } from '@mui/material';
import { ForwardedRef, forwardRef } from 'react';

import { removeSpacesAtStart } from '@/modules/common/application/string';
import theme from '@/styles/theme';

import { getColorForLetter } from './utils';

interface Props {
  input?: string;
  styles?: React.CSSProperties;
  backgroundColor?: string;
  textColor?: string;
}

const LetterAvatars = forwardRef(function LetterAvatars(
  props: Props,
  ref: ForwardedRef<HTMLDivElement>
) {
  const { input = '', styles, backgroundColor, textColor } = props;

  const inputArray: string[] = input.split(' ');
  function getAvatarLetter(): string {
    if (!inputArray) return '';
    if (inputArray.length > 1) {
      return `${removeSpacesAtStart(inputArray[0]).charAt(0).toUpperCase()}${removeSpacesAtStart(
        inputArray[1]
      )
        .charAt(0)
        .toUpperCase()}`;
    } else {
      return `${removeSpacesAtStart(inputArray[0]).charAt(0).toUpperCase()}${removeSpacesAtStart(
        inputArray[0]
      )
        .charAt(1)
        .toUpperCase()}`;
    }
  }

  return (
    <div>
      {inputArray.length > 0 ? (
        <Avatar
          {...props}
          ref={ref}
          sx={{
            ...styles,
            bgcolor: backgroundColor
              ? backgroundColor
              : getColorForLetter(removeSpacesAtStart(inputArray[0]).charAt(0).toUpperCase()),
            color: textColor ? textColor : theme.palette.colors.lightGrey,
          }}
        >
          {getAvatarLetter()}
        </Avatar>
      ) : (
        <Avatar
          {...props}
          ref={ref}
          data-testid="avatar"
          sx={{
            ...styles,
          }}
        />
      )}
    </div>
  );
});

export default LetterAvatars;
